<template>
  <section id="services">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative">
      <div class="relative">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pt-20 pb-12">
          <h2 class="h2 text-3xl text-theme-900" data-aos="fade-up">提供サービス</h2>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1">
      <div class="relative z-10 col-start-1 row-start-1 px-16 pb-32 pt-16 pb-3 h-section bg-image-1">
        <h3 class="text-xl font-bold text-white sm:text-2xl md:text-3xl pb-4" data-aos="fade-up">
          からだトータルサポート
        </h3>
        <p class="text-lg font-bold text-white" data-aos="fade-up">
          定額でストレッチ・エクササイズ・座学が受け放題！
        </p>
        <a class="absolute flex pl-16 p-4 bg-white hover:bg-gray-100 button" data-aos="fade-up" href="karada-support">
          <img class="w-3 mr-2" :src="require('@/images/arrow.svg')" />
          <span class="block font-bold text-theme-900">詳細を見る</span>
        </a>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2">
      <div class="relative z-10 col-start-1 row-start-1 px-16 pb-32 pt-16 pb-3 h-section bg-image-2">
        <h3 class="text-xl font-bold text-white sm:text-2xl md:text-3xl pb-4" data-aos="fade-up">
          パーソナルセッション
        </h3>
        <p class="text-lg font-bold text-white" data-aos="fade-up">
          完全個人制！ あなたの悩みを最短で解決します。
        </p>
        <a class="absolute flex pl-16 p-4 bg-white hover:bg-gray-100 button" data-aos="fade-up" href="personal-session">
          <img class="w-3 mr-2" :src="require('@/images/arrow.svg')" />
          <span class="block font-bold text-theme-900">詳細を見る</span>
        </a>
      </div>

      <div
        class="relative z-10 col-start-1 row-start-2 md:col-start-2 md:row-start-1 px-16 pb-32 pt-16 pb-3 h-section bg-image-3"
      >
        <h3 class="text-xl font-bold text-white sm:text-2xl md:text-3xl pb-4" data-aos="fade-up">
          体質改善デトックスプログラム
        </h3>
        <p class="text-lg font-bold text-white" data-aos="fade-up">
          あなたに合わせてプログラムを作成します。
        </p>
        <a class="absolute flex pl-16 p-4 bg-white hover:bg-gray-100 button" data-aos="fade-up" href="detox-program">
          <img class="w-3 mr-2" :src="require('@/images/arrow.svg')" />
          <span class="block font-bold text-theme-900">詳細を見る</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Services",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.bg-image-1 {
  background-image: url("./../images/services-background-01.jpg");
  background-size: cover;
  background-position: center;
}
.bg-image-2 {
  background-image: url("./../images/services-background-02.jpg");
  background-size: cover;
  background-position: center;
}
.bg-image-3 {
  background-image: url("./../images/services-background-03.jpg");
  background-size: cover;
  background-position: center;
}
.button {
  width: 240px;
  right: 0;
  left: 0;
  bottom: 0;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
  cursor: pointer;
  @screen sm {
    left: normal;
    margin-right: 2rem;
  }
}
</style>
